:host {
  --tab-color: var(--cpsl-color-text-secondary);
  --tab-gap: 2px;
  --tab-icon-height: 16px;
  --tab-icon-width: 16px;

  display: flex;
  flex: 1 1 auto;
  align-items: center;

  cursor: pointer;

  z-index: 10;

  ::slotted([slot='start']) {
    --icon-color: var(--tab-color);
    --height: var(--tab-icon-height);
    --width: var(--tab-icon-width);
  }

  ::slotted([slot='end']) {
    --icon-color: var(--tab-color);
    --height: var(--tab-icon-height);
    --width: var(--tab-icon-width);
  }
}

:host(.selected) {
  --tab-color: var(--cpsl-color-text-primary);
}

.tab-container {
  align-items: center;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  text-align: center;
  white-space: nowrap;
  font-weight: 500;
  color: var(--tab-color);
  display: flex;
  gap: var(--tab-gap);

  padding-top: var(--tab-top-padding);
  padding-bottom: var(--tab-bottom-padding);
  padding-left: var(--tab-left-padding);
  padding-right: var(--tab-right-padding);
}

.content {
  flex: 1 1 auto;
}
